export default __webpack_public_path__ + "static/media/pixul.e23ed005.svg";